import permissions from 'common/system-permissions'
import usePermissions from 'common/use-permissions'

export default () => usePermissions(permissions.MANAGE_COLLEGE_APPLICATION_ROUNDS)
